import { CaseDisplayGroup, CaseDisplayGroupLocationView } from "generated/graphql";

interface GroupAndLocation {
  group: CaseDisplayGroup;
  location: CaseDisplayGroupLocationView;
}

interface DisplayGroupsByLocation {
  caseHome: GroupAndLocation[];
  casesFilter: GroupAndLocation[];
  caseInfo: GroupAndLocation[];
  sections: {
    [sectionId: number]: GroupAndLocation[];
  };
  fields: {
    [fieldId: number]: GroupAndLocation[];
  };
}

function rankSort(a: GroupAndLocation, b: GroupAndLocation) {
  return a.location.rank - b.location.rank;
}

export type GROUP_LOCATION_WHERE = "CaseInfo" | "CaseHome" | "Section" | "Field" | "Collect" | "CasesFilter";

export function useGroupLocations(caseDisplayGroups: CaseDisplayGroup[]): DisplayGroupsByLocation {
  const displayGroupsByLocations: DisplayGroupsByLocation = {
    caseHome: [],
    casesFilter: [],
    caseInfo: [],
    sections: {},
    fields: {},
  };

  caseDisplayGroups.forEach((cdg) => {
    cdg.locations.forEach((location) => {
      const sectionId = location.sectionId;
      const fieldId = location.fieldId;
      if (location.caseHome) {
        displayGroupsByLocations.caseHome.push({
          group: cdg,
          location,
        });
      } else if (location.casesFilter) {
        displayGroupsByLocations.casesFilter.push({ group: cdg, location });
      } else if (location.caseInfo) {
        displayGroupsByLocations.caseInfo.push({ group: cdg, location });
      } else if (sectionId !== undefined && sectionId !== null) {
        const section = displayGroupsByLocations.sections[sectionId];
        if (section !== undefined) {
          section.push({ group: cdg, location });
        } else {
          displayGroupsByLocations.sections[sectionId] = [{ group: cdg, location }];
        }
      } else if (fieldId !== undefined && fieldId !== null) {
        const field = displayGroupsByLocations.fields[fieldId];
        if (field !== undefined) {
          field.push({ group: cdg, location });
        } else {
          displayGroupsByLocations.fields[fieldId] = [{ group: cdg, location }];
        }
      }
    });
  });
  displayGroupsByLocations.caseHome.sort(rankSort);
  displayGroupsByLocations.casesFilter.sort(rankSort);
  displayGroupsByLocations.caseInfo.sort(rankSort);
  Object.values(displayGroupsByLocations.sections).forEach((s) => s.sort(rankSort));
  Object.values(displayGroupsByLocations.fields).forEach((f) => f.sort(rankSort));

  return displayGroupsByLocations;
}
